// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__rzaZH","footer":"ModalUpdate_footer__1wgaH"};